export const GET_DONATE_DATA_REQUEST = "GET_DONATE_DATA_REQUEST";
export const GET_DONATE_DATA_SUCCESS = "GET_DONATE_DATA_SUCCESS";
export const GET_DONATE_DATA_FAILURE = "GET_DONATE_DATA_FAILURE";

export const GET_LEND_DATA_REQUEST = "GET_LEND_DATA_REQUEST";
export const GET_LEND_DATA_SUCCESS = "GET_LEND_DATA_SUCCESS";
export const GET_LEND_DATA_FAILURE = "GET_LEND_DATA_FAILURE";

export const GET_HOME_DATA_REQUEST = "GET_HOME_DATA_REQUEST";
export const GET_HOME_DATA_SUCCESS = "GET_HOME_DATA_SUCCESS";
export const GET_HOME_DATA_FAILURE = "GET_HOME_DATA_FAILURE";